(() => {
  function init(root) {
    if (root.dataset.rfReady) return;
    root.dataset.rfReady = 'true';
    const productData = JSON.parse(root.querySelector('[data-rf-product-json]').textContent);
    const product = Array.isArray(productData?.variants) ? productData : null;
    const discounts = JSON.parse(root.querySelector('[data-rf-kit-discounts]')?.textContent || '{}');
    const strings = JSON.parse(root.querySelector('[data-rf-strings]').textContent);
    const message = root.querySelector('[data-rf-message]');
    const image = root.querySelector('[data-rf-main-image]');
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: root.dataset.currency }).format(cents / 100);
    const quantity = () => Number(root.querySelector('[data-rf-kit-radio]:checked')?.value || 1);
    const selectors = count => Array.from(root.querySelectorAll(`[data-rf-kit-finish][data-rf-kit-count="${count}"]`));
    const offer = count => window.RoveforgeOffers.resolveKit({ product, quantity: count, finishes: selectors(count).map(select => select.value), discounts, previewUnitPrice: Number(root.dataset.unitPrice) });
    function showFinish(finish, updateUrl = false) {
      const thumb = root.querySelector(`[data-rf-thumbnail="${finish}"]`);
      if (!thumb) return;
      image.src = thumb.dataset.image;
      image.srcset = `${thumb.dataset.small} 640w, ${thumb.dataset.image} 1600w`;
      image.alt = thumb.dataset.alt;
      root.querySelectorAll('[data-rf-thumbnail]').forEach(button => {
        const active = button === thumb;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
      });
      if (updateUrl && location.pathname.includes('/products/')) {
        const variant = product?.variants.find(item => item.options.some(option => option.toLowerCase() === finish));
        if (variant) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
      }
    }
    function update() {
      const count = quantity();
      root.querySelectorAll('[data-rf-kit-options]').forEach(options => { options.hidden = Number(options.dataset.rfKitOptions) !== count; });
      for (let kit = 1; kit <= 3; kit += 1) {
        const current = offer(kit);
        root.querySelector(`[data-rf-kit-price="${kit}"]`).textContent = money(current.amount);
        const compare = root.querySelector(`[data-rf-kit-compare="${kit}"]`);
        compare.textContent = money(current.compareAt);
        compare.hidden = current.saving === 0;
        root.querySelector(`[data-rf-kit-saving="${kit}"]`).textContent = current.saving ? strings.save.replace('__amount__', money(current.saving)) : strings.standard;
        selectors(kit).forEach(select => {
          const thumb = root.querySelector(`[data-rf-thumbnail="${select.value}"]`);
          const preview = select.closest('.rf-kit-item').querySelector('[data-rf-kit-image]');
          if (thumb) preview.src = thumb.dataset.small;
        });
      }
      const order = offer(count);
      const submit = root.querySelector('[data-rf-submit]');
      if (submit) {
        submit.disabled = !order.available;
        submit.querySelector('[data-rf-button-label]').textContent = order.available ? strings.add : strings.unavailable;
      }
      const variantInput = root.querySelector('[data-rf-variant]');
      if (variantInput) variantInput.value = order.lineItems[0]?.id || '';
      const formQuantity = root.querySelector('[data-rf-form-quantity]');
      if (formQuantity) formQuantity.value = count;
      root.querySelector('[data-rf-price]').textContent = money(order.amount);
      root.querySelector('.rf-price-note').textContent = count > 1 ? strings.total : strings.each;
      root.querySelector('[data-rf-sticky-price]').textContent = money(order.amount) + ' ' + root.dataset.currency;
    }
    root.querySelectorAll('[data-rf-kit-radio]').forEach(radio => radio.addEventListener('change', () => {
      message.textContent = '';
      update();
      showFinish(selectors(quantity())[0].value, true);
    }));
    root.querySelectorAll('[data-rf-kit-finish]').forEach(select => select.addEventListener('change', () => {
      message.textContent = '';
      update();
      showFinish(select.value, Number(select.dataset.rfItemIndex) === 0);
    }));
    root.querySelectorAll('[data-rf-thumbnail]').forEach(button => button.addEventListener('click', () => {
      selectors(quantity())[0].value = button.dataset.rfThumbnail;
      message.textContent = '';
      update();
      showFinish(button.dataset.rfThumbnail, true);
    }));
    root.querySelector('[data-rf-preview]')?.addEventListener('click', () => { message.textContent = strings.preview; });
    root.querySelector('.rf-form')?.addEventListener('submit', async event => {
      event.preventDefault();
      const order = offer(quantity());
      if (!order.available) return;
      const button = root.querySelector('[data-rf-submit]');
      button.disabled = true;
      button.querySelector('[data-rf-button-label]').textContent = strings.adding;
      message.textContent = '';
      try {
        const response = await fetch(root.dataset.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: order.lineItems }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || strings.error);
        location.assign(root.dataset.cartUrl);
      } catch (error) {
        message.textContent = error.message || strings.error;
        button.disabled = false;
        button.querySelector('[data-rf-button-label]').textContent = strings.add;
      }
    });
    root.querySelectorAll('[data-rf-play]').forEach(button => button.addEventListener('click', async () => {
      const video = button.parentElement.querySelector('video');
      button.disabled = true;
      try { await video.play(); button.hidden = true; }
      catch (error) { button.disabled = false; button.setAttribute('aria-label', strings.videoError); button.title = strings.videoError; }
    }));
    root.addEventListener('play', event => { root.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); }); }, true);
    const sticky = root.querySelector('[data-rf-sticky]');
    const observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, { threshold: 0, rootMargin: '0px' });
    observer.observe(root.querySelector('.rf-order-row'));
    const queryId = new URLSearchParams(location.search).get('variant');
    const initialVariant = product?.variants.find(variant => String(variant.id) === queryId) || product?.variants.find(variant => variant.available);
    const finish = initialVariant?.options[0]?.toLowerCase() || 'black';
    root.querySelectorAll('[data-rf-kit-finish]').forEach(select => { select.value = finish; });
    update();
    showFinish(finish);
  }
  document.addEventListener('change', event => { if (event.target.matches('[data-rf-country]')) event.target.form.requestSubmit(); });
  function scan(scope = document) { scope.querySelectorAll('[data-rf-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true }); else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
